export default {
  anyMistakes:
    'Om du tror att några uppgifter på den här sidan är felaktiga ber vi dig att ',
  contactUs: 'kontakta oss.',
  social: 'Vi är sociala | Följ oss',
}
